import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Select, { SelectOption } from '@amzn/meridian/select';
import Pagination from '@amzn/meridian/pagination';

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

interface TablePaginationProps {
  pagination: {
    currentPage: number;
    totalPages: number;
    itemsPerPage: number;
    visibleIndices: number[];
    handlePageChange: (page: number) => void;
    handleItemsPerPageChange: (size: number) => void;
  };
  totalItems: number;
}

const TablePagination: React.FC<TablePaginationProps> = ({ pagination, totalItems }) => (
  <Row spacing="400" spacingInset="300" alignmentHorizontal="start" alignmentVertical="center">
    <Row spacing="200" alignmentVertical="center">
      <Text>Rows per page:</Text>
      <Select
        value={pagination.itemsPerPage.toString()}
        onChange={(value: string) => pagination.handleItemsPerPageChange(Number(value))}
        width={100}
      >
        {PAGE_SIZE_OPTIONS.map((opt) => (
          <SelectOption key={opt} label={opt.toString()} value={opt.toString()} />
        ))}
      </Select>
      <Text>
        {totalItems > 0
          ? `Showing ${pagination.visibleIndices[0] + 1} to ${pagination.visibleIndices[1]} of ${totalItems} items`
          : 'No items to display'}
      </Text>
    </Row>
    <Pagination
      currentPage={pagination.currentPage}
      numberOfPages={pagination.totalPages}
      onChange={pagination.handlePageChange}
    />
  </Row>
);

export default TablePagination;
